import type { ChatBotChain } from '@common/types/chat-bot-chain.type';

import { Injectable, inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, filter } from 'rxjs/operators';

import { ChatBotChainsHttpService } from './chat-bot-chains.http.service';
import { ChatBotChainsService } from './chat-bot-chains.service';

import ChatBotChainsActions from './chat-bot-chains.actions';

@Injectable()
export class ChatBotChainsCollectionEffect {
    private readonly actions$ = inject(Actions);
    private readonly chatBotChainsHttpService = inject(ChatBotChainsHttpService);
    private readonly chatBotChainsService = inject(ChatBotChainsService);

    public readonly loadCrmDealsRequest$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ChatBotChainsActions.loadCollectionRequest),
            filter(({ messenger, chatBotId }) => Boolean(messenger) && Boolean(chatBotId)),
            exhaustMap(({ messenger, chatBotId }) =>
                this.chatBotChainsHttpService.getChatBotChains(messenger, chatBotId).pipe(
                    map((chatBotChains: ChatBotChain[]) =>
                        ChatBotChainsActions.loadCollectionSuccess({
                            messenger,
                            chatBotId,
                            chatBotChains: this.chatBotChainsService.normalizeChatBotChains(chatBotChains),
                        })
                    ),
                    catchError((error) => [ChatBotChainsActions.loadCollectionFailure({ messenger, chatBotId, error })])
                )
            )
        )
    );
}
